module.exports = __webpack_public_path__ + "static/media/Infeksjon.1d910e28.m4a";